import { cn } from 'common/utils'
import { UserStats } from 'components/Stats'

export const UserHeader = ({
  user,
  title,
  titleSuffix,
  children,
  ...props
}) => (
  <SectionHeader
    title={title ? title : <span className="text-2xl">{user.name}</span>}
    subtitle={<UserStats user={user}>{children}</UserStats>}
    {...props}
  />
)

export const SectionHeader = ({
  title,
  subtitle,
  leftmost,
  rightmost,
  big,
  className,
}) => (
  <div className={cn('z-0 flex items-center justify-between', className)}>
    <div className="flex items-center">
      {leftmost}
      <div className={cn(leftmost && 'ml-2', 'break-words')}>
        <div
          className={cn(
            big && 'text-3xl font-semibold leading-none',
            subtitle && 'mb-1',
          )}
        >
          {title}
        </div>
        {subtitle && <div className="font-light text-gray-500">{subtitle}</div>}
      </div>
    </div>
    {rightmost}
  </div>
)

export default SectionHeader
